import { render, staticRenderFns } from "./membership-calculation-incomes.vue?vue&type=template&id=35136b7c&scoped=true"
import script from "./membership-calculation-incomes.vue?vue&type=script&lang=js"
export * from "./membership-calculation-incomes.vue?vue&type=script&lang=js"
import style0 from "./membership-calculation-incomes.vue?vue&type=style&index=0&id=35136b7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35136b7c",
  null
  
)

export default component.exports